import { SOUND_ASSETS, type SoundChannel } from '../constants/settings.constants'
import { settingsService, shouldPlaySound } from '../services/settings.service'

/**
 * Centralised notification-sound helper. Reads the current settings *at the
 * moment of the call* (not at component mount) so toggling a flag in the
 * settings page takes effect immediately. Silently no-ops if the user has
 * muted the channel, enabled mute-all, or turned on DND.
 */
export function playNotificationSound(channel: SoundChannel, volume = 0.6): void {
  try {
    const settings = settingsService.get()
    if (!shouldPlaySound(settings.notifications, channel)) return
    const src = SOUND_ASSETS[channel]
    if (!src) return
    const audio = new Audio(src)
    audio.volume = Math.max(0, Math.min(1, volume))
    void audio.play().catch(() => {
      // Browsers may block autoplay before the user has interacted with the
      // page — this is intentional, not an error worth surfacing.
    })
  } catch {
    // Audio constructor failures (test environments, etc.) are non-fatal.
  }
}
